import * as React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { connect } from "react-redux";
import {Routine} from "redux-saga-routines";
import {Action, ActionFunctionAny} from "redux-actions";
import { useIntl } from "react-intl";
import styled from "styled-components";
import {  deleteCustomer, getPaymentForNew } from "../Store/routines";
import { CreateCustomer, createCustomer } from "../Store/actions";
import {PolicyNameEnum} from "../../PolicyNameEnum";
import {GlobalRoles} from "../../GlobalRoles";
import {accessToCustomer, checkPermissionsForCustomer} from "../../Policy/rightsUtil";
import { LoaderWrap } from "../Form/styled";
import Loader from "@Elements/Loader";
import { AppState } from "@Safemate/Store/types";
import { IFullCustomerWithPolicy } from "@Safemate/Model/Customer";
import {AllPermissions, PolicyContext} from "@Safemate/Policy/Provider";



const DeleteButton = styled(Button)`
  margin-top:10px;
  width: 100%;
`;

const NewOrgButton = styled(Button)`
  margin-top:10px;
  width: 100%;
`;

interface FooterProps{
  selectedCustomer: IFullCustomerWithPolicy;
  processingDelete: boolean;
  createCustomer: CreateCustomer;
  deleteCustomer: Routine<ActionFunctionAny<Action<any>>>;
  getPaymentForNew: Routine<ActionFunctionAny<Action<any>>>;
}
const mapStateToProps = ( { subUnits: {customer: {selectedCustomer}, initialization: { processingDelete }}} : AppState) => {
  return{
    selectedCustomer,
    processingDelete
  }
};
const mapDispatchFromState = {
  deleteCustomer,
  createCustomer,
  getPaymentForNew
}

export const Footer = connect(mapStateToProps, mapDispatchFromState)(
  ({ deleteCustomer, createCustomer, getPaymentForNew, selectedCustomer, processingDelete}: FooterProps) => {

    const { formatMessage } = useIntl();

    if(!selectedCustomer) return null;

    const { firm: { parent = 0 } = {}, numberOfDevices = 0 } = selectedCustomer;

    const permissions = React.useContext(PolicyContext) as Map<PolicyNameEnum, AllPermissions>;
    
    const handleDelete = () => {
      deleteCustomer(selectedCustomer.customerId);
    }
    const handleNew = () => {
      createCustomer();
      getPaymentForNew(selectedCustomer.customerId);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    const hasAccess = checkPermissionsForCustomer(permissions, PolicyNameEnum.EDIT_SUB_ORGS, selectedCustomer.customerId);
    
    let customerName = selectedCustomer.firm.lastName;

    if(customerName.length > 15){
      customerName = customerName.substring(0.,15) + "...";
    }


  return(
    <Row>
      {hasAccess && <Col md={12}>
        {processingDelete 
          ? <LoaderWrap><Loader/></LoaderWrap>
          : <DeleteButton onClick={handleDelete} disabled={!(numberOfDevices == 0 && parent != 0)}>
              {formatMessage({id: "Delete", defaultMessage: "SLETTE"})} {customerName}
            </DeleteButton>}

        <NewOrgButton onClick={handleNew}>
          {formatMessage({id: "newSuborg", defaultMessage: "LEGG TIL NY UNDERAVDELING"})}
        </NewOrgButton>
      </Col> }
    </Row>
  )
})

export default Footer;
